import { lazy } from 'react';

const Dashboard = lazy(() =>
  import('../../components/pages/Dashboard/Dashboard'),
);
const Slider = lazy(() => import('../../components/pages/Slider/Slider'));
const RepairOrderDetails = lazy(() =>
  import('../../components/features/RepairOrderDetails/RepairOrderDetails'),
);

const BatchHistoryPage = lazy(() =>
  import('../../components/pages/BatchHistory/BatchHistoryPage'),
);

const AwhPage = lazy(() => import('../../components/pages/Awh/AwhPage'));

export const operationsRoutes = [
  { path: '/awh', permission: 'awh.view', access: 'authenticated', Component: AwhPage },
  {
    path: '/batch-history',
    anyPermissions: ['pz04.view', 'pz05.view'],
    access: 'authenticated',
    Component: BatchHistoryPage,
  },
  {
    path: '/dashboard',
    permission: 'dashboard.view',
    access: 'authenticated',
    roles: ['ADMIN', 'KONTROLER'],
    Component: Dashboard,
  },
  {
    path: '/slider',
    permission: 'dashboard.view',
    access: 'authenticated',
    roles: ['ADMIN', 'KONTROLER'],
    Component: Slider,
  },
  {
    path: '/repair-order/:id',
    permission: 'pz04.repair',
    access: 'authenticated',
    roles: ['ADMIN', 'KONTROLER'],
    Component: RepairOrderDetails,
  },
];
